import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  addManualPacket,
  confirmBillingMatch,
  importPacketaCsv,
  packetLoad,
  packetLoadByOrder,
  packetsLoadAll,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(packetsLoadAll.type, send, socket);
  yield takeEvery(packetLoad.type, send, socket);
  yield takeEvery(packetLoadByOrder.type, send, socket);
  yield takeEvery(addManualPacket.type, send, socket);
  yield takeEvery(importPacketaCsv.type, send, socket);
  yield takeEvery(confirmBillingMatch.type, send, socket);
}
